import createPurchases from './purchases'
import createReview from './review'
import createBook from './book'

export default ({ api, firebase }) => {
  const db = firebase.database()
  const bookRepository = createBook({ db })

  return {
    purchasesRepository: createPurchases({ purchasesAPI: api.purchases }),
    reviewRepository: createReview({ db, bookRepository }),
    bookRepository
  }
}
